// src/admin/AdminLogin.jsx
import React, { useState } from "react";
import { Lock, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { PROFILE_API } from "../data/api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Both fields are required");
      return;
    }

    setLoading(true);

    try {
      // ✅ Call login API
      const response = await axios.post(PROFILE_API.GET_ALL + "/login", {
        Email: email,
        Password: password,
        Type: "Admin", // Always Admin
      });

      const data = response.data.user;

      // ✅ Fixed Admin ID
      const fixedAdminId = 1011; // Set your fixed admin ID here
      localStorage.setItem("userToken", fixedAdminId);
      localStorage.setItem(
        "userInfo",
        JSON.stringify({
          ...data,
          userId: fixedAdminId, // override API userId
        })
      );

      // ✅ Redirect to Admin Dashboard
      navigate("/admin_dashboard");
    } catch (err) {
      console.error(err);
      setError(err.response?.data || "Invalid email or password or server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-green-200 to-green-400">
      <div className="bg-white shadow-2xl rounded-xl w-full max-w-md p-8">
        <h2 className="text-3xl font-bold text-green-700 mb-6 text-center">
          Admin Login
        </h2>

        {error && (
          <div className="bg-red-100 text-red-700 p-2 rounded mb-4 text-center">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Email */}
          <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 focus-within:border-green-500 transition">
            <User className="text-gray-400 mr-2" />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full outline-none"
              required
            />
          </div>

          {/* Password */}
          <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 focus-within:border-green-500 transition">
            <Lock className="text-gray-400 mr-2" />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full outline-none"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 rounded-lg transition"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <p className="text-center text-gray-500 text-sm mt-4">
          &copy; 2025 Admin Panel. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
